module.exports = __webpack_public_path__ + "static/media/erweima.ba6b0ce4.png";